export const getFromTo = () => {
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - 10);
    let from = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    let to = fromDate.getFullYear() + '-' + ((+fromDate.getMonth()) + 1) + '-' + (fromDate.getDate());
    // console.log(from, to)
    return [from, to];
}

export const getGraphDateTime = () => {
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - 10);
    let Gfrom = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    let Gto = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    // console.log(from, to)
    return [Gfrom, Gto];
}

// export function getDateTimeForTab3() {
//     // Get the current date
//     var currentDate = new Date();

//     // Get the date from 10 days ago
//     var tenDaysAgo = new Date();
//     tenDaysAgo.setDate(currentDate.getDate() - 7);

//     // Format the dates if needed
//     var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
//     var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
//     return {
//         Today: formattedCurrentDate,
//         LastDay: formattedTenDaysAgo
//     }
// }


export function getDateTimeForTab3() {
    const currentDate = new Date();

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(currentDate.getDate() - 7);

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, "0");

        const months = [
            "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
            "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
        ];

        const month = months[date.getMonth()];
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return {
        Today: formatDate(currentDate),
        LastDay: formatDate(sevenDaysAgo)
    };
}
  
export function getDateTimeForDashboardTab1() {
    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 10);

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}

// this is monthly (date) energyreporting
export function getDateTimeForDashboardTabMonthly2() {
    // Helper function to format month names
    function getMonthName(monthIndex) {
        const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        return monthNames[monthIndex];
    }

    // Helper function to format the date as 'MMM-YYYY' (e.g., JAN-2024)
    function formatMonthYear(date) {
        const month = getMonthName(date.getMonth());
        const year = date.getFullYear();
        return `${month}-${year}`;
    }

    // Get the current date
    const currentDate = new Date();

    // Get the date 10 days ago
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 10);

    // Format the dates to 'MMM-YYYY'
    const formattedCurrentDate = formatMonthYear(currentDate);
    const formattedTenDaysAgoDate = formatMonthYear(tenDaysAgo);

    return {
        Today: formattedCurrentDate,      // e.g., JAN-2024
        LastDay: formattedTenDaysAgoDate  // e.g., DEC-2023 (if 10 days ago crosses months)
    };
}

export function getDateTimeForPvParameter() {
    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 2);

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}


export function getDateTimeForTab2() {
    // Get the current date
    let currentDate = new Date();

    // Get the date from 10 days ago
    let tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate());

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}

export const getGraphTab3DateTime = () => {
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - 10);
    let Gfrom = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate() - 7);
    let Gto = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    // console.log(from, to)
    return [Gfrom, Gto];
}



export function getFormattedDateTime(daysOffset = 0) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function getFormattedStaticDateTime(daysOffset = 0) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = '05'
    const minutes = '00';

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}


export function getFormattedDateTimeForHYBRD(daysOffset = 0) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}



// this is monthly tap

export function getDateTimeForDashboardTabMonthly() {
    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 10);

    // Format the dates to show only month and year (e.g., "December 2024")
    var options = { year: 'numeric', month: 'long' };

    var formattedCurrentDate = currentDate.toLocaleString('en-US', options); // Example: "December 2024"
    var formattedTenDaysAgo = tenDaysAgo.toLocaleString('en-US', options);   // Example: "December 2024"

    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}


// this is hourly data

export function getDateTimeForDashboardTabHourly() {
    // Helper function to format month names
    function getMonthName(monthIndex) {
        const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        return monthNames[monthIndex];
    }

    // Helper function to format the date-time
    function formatDateTime(date) {
        const day = String(date.getDate()).padStart(2, '0'); // Day with leading zero
        const month = getMonthName(date.getMonth()); // Month name (e.g., FEB)
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0'); // Hours with leading zero
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Minutes with leading zero
        const seconds = String(date.getSeconds()).padStart(2, '0'); // Seconds with leading zero

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }

    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 10);

    // Format the dates with time
    var formattedCurrentDateTime = formatDateTime(currentDate);
    var formattedTenDaysAgoDateTime = formatDateTime(tenDaysAgo);

    return {
        Today: formattedCurrentDateTime,
        LastDay: formattedTenDaysAgoDateTime
    };
}